import type { ServicesTypes } from "@/redux/services/serviceTypes";

export const initialState: ServicesTypes = {
  fetching: false,
  error: null,
  ifscDetails: null,
  bankAccountDetails: null,
  gstDetails: null,
  success: null,
  panVerifyDetails: null,
  shippingAddressPanVerifyDetails: null,
  tanVerifyDetails: null,
  panAadharLinkStatus: null,
  authorizedPanVerifyDetails: null,
};
